// import React from 'react';
import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// import frenchfries from "../assests/img/SliderImages/yum-banner-1.jpg";
import join1 from "../assests/img/SliderImages/join1.png";
import join2 from "../assests/img/SliderImages/join2.png";

import { useLocation, useParams } from 'react-router-dom';
// import blueyumwayseasmith from "../assets/img/blueyumwayseasmith.png";
// import aboutbannerx10 from "../assets/img/aboutbannerX10.png";
import { Link } from 'react-router-dom';
// import year_title_bg from '../assets/img/update_2/bg/year_title_bg.svg'
// import year_title_bg51 from '../assets/img/update_2/bg/year_title_bg51.svg'
// import bgbanner2 from '../assets/img/update_2/bg/bannerbg2.png'
// import mapx1 from "../assets/img/mapx1.jpg";
// import mapx444 from "../assets/img/mapx444.jpg";
// import mapx444yum from "../assets/img/mapx444yum.png";
// import potatoo from "../assets/img/potatoo2.png";
// import potatoo1 from "../assets/img/potatoo1.png";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
// import about_6_1 from "../assets/img/update_2/normal/about_6_1.png";
// import dishround from "../assets/img/update_2/normal/dishround.png";
// import roundpotato from "../assets/img/update_2/normal/roundedpotato.png";
// import contractfarm01 from "../assets/img/update_2/icon/contractfarm01.jpg";
// import farmicon1 from "../assets/img/update_2/icon/farmicon1.svg";
// import farm111 from "../assets/img/update_2/icon/farm111.jpg";
// import farming222 from "../assets/img/update_2/icon/farming222.jpg";
// import consistent01 from "../assets/img/update_2/icon/consistent01.jpg";
// import consistenet111 from "../assets/img/update_2/icon/consistenet111.jpg";
// import consistent222 from "../assets/img/update_2/icon/consistent222.jpg";
// import quick01 from "../assets/img/update_2/icon/quick01.jpg";
// import quick111 from "../assets/img/update_2/icon/quick111.jpg";
// import quick222 from "../assets/img/update_2/icon/quick222.jpg";
// import longshelf01 from "../assets/img/update_2/icon/longshelf01.jpg";
// import longshelf111 from "../assets/img/update_2/icon/longshlef111.jpg";
// import longshelf222 from "../assets/img/update_2/icon/longshelf222.jpg";
// import tiger01 from "../assets/img/update_2/icon/tiger01.jpg";
// import proudlymade111 from "../assets/img/update_2/icon/proudlymade111.jpg";
// import tiger222 from "../assets/img/update_2/icon/tiger222.jpg";
// import flexibility01 from "../assets/img/update_2/icon/flexibility01.jpg";
// import flexibility111 from "../assets/img/update_2/icon/fexibility111.jpg";
// import flexibility222 from "../assets/img/update_2/icon/flexibility222.jpg";
// import testicardimg from "../assets/img/update_2/normal/testi-card_img.png";
// import abb from "../assets/img/update_2/normal/abb.png";
// import abb1 from "../assets/img/update_2/normal/mission1.png";
import bulk from "../assets/img/update_2/normal/bulk2.png";
import tastethediff from "../assets/img/update_2/normal/tastethediff.png";
import joinglobal1 from "../assets/img/update_2/normal/joinglobal1.png";
// import abb from "../assets/img/update_2/normal/abb.mp4";
// import qualitydrivenupdated1 from "../assets/img/update_2/normal/qualitydrivenupdated1.jpg";
// import mission1 from "../assets/img/update_2/normal/mission1.png";
// import vision1 from "../assets/img/update_2/normal/vision1.png";
// import customerfocuedupdated1 from "../assets/img/update_2/normal/customerfocusedupdated1.jpg";
// import td11 from "../assets/img/update_2/normal/td11.jpg";
// import backwardintegration1 from "../assets/img/update_2/normal/backwardintegration1.png";
// import backint from "../assets/img/update_2/normal/backint.png";
// import bgfriesupdated from "../assets/img/update_2/normal/bgfriesupdated.jpg";
// import testicardshape from "../assets/img/update_2/normal/testi-card_shape_1.png";
// import testicardshapeimg from "../assets/img/update_2/normal/testi-card_shape_2.png";
// import potatoban1 from "../assets/img/potatoban1.png";
// import header_about from "../assets/img/header_about.png";

// import shrimpovingimgx1 from "../assets/img/update_2/normal/shrimpmovingimgx1.png";
// import potatosmovingimgx1 from "../assets/img/update_2/normal/potatomovingimgx1.png";
// import HoveredMap from '../components/HoveredMap';
// import certifications6 from "../assets/img/certifications7.png";
// import certifications4 from "../assets/img/certifications8.png";    
// import certificationsSINGLE from "../assets/img/certificationsSINGLE.png";

import feature_bg_51 from "../assets/img/update_2/bg/feature_bg_51.jpg"

import Footer from './footer';

import c1 from "../assets/img/update_2/certificates/c1.png";
import c2 from "../assets/img/update_2/certificates/c2.png";
import c3 from "../assets/img/update_2/certificates/c3.png";
import c4 from "../assets/img/update_2/certificates/c4.png";
import c5 from "../assets/img/update_2/certificates/c5.png";
import c6 from "../assets/img/update_2/certificates/c6.png";

import { Helmet } from 'react-helmet';
const CertificatImg = [ c1, c2, c3, c4, c5, c6 ];


const Joinourglobaltable = (props) => {
    const location = useLocation();

    useEffect(() => {
        const { hash } = location;
        if (hash) {
            const id = hash.substring(1);
            const element = document.getElementById(id);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
    }, [location]);



    // const location = useLocation();

    // useEffect(() => {
    //     window.scrollTo(0, 0);
    // }, [location]);

    // const handleClick = () => {
    //     window.location.href = '/Idgnew/about';
    //     window.scrollTo(0, 0);
    // };



    const settings = {
        dots: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2500, // Change this value for faster or slower speed
        prevArrow: <></>,
        nextArrow: <></>,
        appendDots: dots => (
            <ul style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
                {dots.map((dot, index) => (
                    <li key={index} style={{ listStyle: 'none', margin: '0 10px' }}>
                        <div
                            style={{
                                width: '10px',
                                height: '10px',
                                borderRadius: '50%',
                                background: index === dot.props.current ? '#F0B323' : '#fff', // Red for active dot, white for others
                                border: '0px solid #333', // Customize the border color
                                cursor: 'pointer',
                                marginTop: '20px',
                            }}
                        />
                    </li>
                ))}
            </ul>
        )
    };

    const settingstwice = {
        dots: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2500, // Change this value for faster or slower speed

        appendDots: dots => (
            <ul style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
                {dots.map((dot, index) => (
                    <li key={index} style={{ listStyle: 'none', margin: '0 10px' }}>
                        <div
                            style={{
                                width: '10px',
                                height: '10px',
                                borderRadius: '50%',
                                background: index === dot.props.current ? '#F0B323' : '#fff', // Red for active dot, white for others
                                border: '0px solid #333', // Customize the border color
                                cursor: 'pointer',
                                marginTop: '20px',
                            }}
                        />
                    </li>
                ))}
            </ul>
        )
    };  
    const settingsscroll11 = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        prevArrow: <></>,
        nextArrow: <></>, 
  responsive: [
    {
      breakpoint: 1024, // screen width <= 1024px
      settings: {
        slidesToShow: 4,
      }
    },
    {
      breakpoint: 768, // screen width <= 768px
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 480, // screen width <= 480px
      settings: {
        slidesToShow: 1,
      }
    }
  ],               
        appendDots: dots => (
            // <ul style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
            <ul style={{ display: 'none', justifyContent: 'center', margin: '20px 0' }}>
                {dots.map((dot, index) => (
                    <li key={index} style={{ listStyle: 'none', margin: '0 10px' }}>
                        <div
                            style={{
                                width: '10px',
                                height: '10px',
                                borderRadius: '50%',
                                background: index === dot.props.current ? '#ff0000' : '#fff', // Red for active dot, white for others
                                border: '0px solid #333', // Customize the border color
                                cursor: 'pointer',
                                marginTop: '20px',
                            }}
                        />
                    </li>
                ))}
            </ul>
        )
    };        
  
    return (


        <div>

<Helmet>
  <title>YUMWAY | Premium Frozen French Fries & Frozen Foods Manufacturer in India</title>

  <meta
    name="description"
    content="YUMWAY is one of India's trusted frozen food brands, offering premium frozen French fries, potato wedges, burger patties, hash browns, and other preservative-free frozen snacks for domestic and global markets."
  />

  <meta
    name="keywords"
    content="YUMWAY, frozen french fries manufacturer India, frozen foods India, frozen potato products, potato wedges, hash browns, burger patties, frozen snacks, frozen food exporter India, preservative free frozen foods"
  />

  <meta name="robots" content="index, follow" />

  <link rel="canonical" href="https://yumwayfood.com/exports" />

  {/* Open Graph */}
  <meta property="og:type" content="website" />
  <meta
    property="og:title"
    content="YUMWAY | Premium Frozen French Fries & Frozen Foods Manufacturer in India"
  />
  <meta
    property="og:description"
    content="Discover premium frozen French fries, potato wedges, burger patties, and other frozen foods from YUMWAY. Trusted quality, natural ingredients, and global exports."
  />
  <meta property="og:url" content="https://yumwayfood.com/exports" />
  <meta property="og:image" content="https://yumwayfood.com/og-image.png" />
  <meta property="og:site_name" content="YUMWAY" />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta
    name="twitter:title"
    content="YUMWAY | Premium Frozen French Fries & Frozen Foods Manufacturer in India"
  />
  <meta
    name="twitter:description"
    content="Premium frozen French fries, potato wedges, burger patties, and more from one of India's trusted frozen food brands."
  />
  <meta
    name="twitter:image"
    content="https://yumwayfood.com/og-image.jpg"
  />
</Helmet>              
         <div className="d-md-block hidearrow">
                <Slider {...settings}>


                    <img
                        width="2000"
                        height="700"
                        src={join1}
                        className="ls-l ls-img-layer"
                        alt="Frozen Potatoes"
                        decoding="async"
                        style={{
                            position: 'absolute',
                            left: '0px',
                            top: '107px',
                        }}
                        data-ls="offsetxin:500; durationin:600; delayin:100; easingin:easeOutBack; rotatein:80; bgcolorin:transparent; colorin:transparent;"
                    />

                    <img
                        width="2000"
                        height="700"
                        src={join2}
                        className="ls-l ls-img-layer"
                        alt="Heritage Banner"
                        decoding="async"
                        style={{
                            position: 'absolute',
                            left: '0px',
                            top: '107px',
                        }}
                        data-ls="offsetxin:500; durationin:600; delayin:100; easingin:easeOutBack; rotatein:80; bgcolorin:transparent; colorin:transparent;"
                    />
                </Slider>
            </div>


            <div class="about-sec overflow-hidden pb-5">
                <div class="container">

                    <div class="row">


                    </div>
                </div>
            </div>



            <div class="about-sec overflow-hidden pb-5">
                <div class="container">
                    <div class="row">
                        <div class="col-xl-7 order-1 order-xl-1" style={{ marginTop: "0px" }}>
                            <div class="title-area mb-30 text-center text-xl-start">
                                <span class="sub-title" style={{ fontFamily:'helvetica' }}><span style={{color:"#F0B323"}}>Why YUMWAY Works</span></span>
                                <h2 class="text-uppercase" style={{ fontFamily:'helvetica',color:'#0f1138 !important'}}>
                                    The Brand Exporters Want on Their Portfolio </h2>
                            </div>
                            {/* <p class="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica',fontWeight:'600' }}>
                            One of India’s Most Trusted Frozen Food Brands — Rooted in Legacy, Loved Worldwide 
                            </p> */}
                            <p class="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                            YUMWAY is not entering the global frozen food market — we’re shaping it. With over 220 years of food preservation wisdom and one of the most advanced frozen potato product manufacturing units in India with manufacturing of YUMWAY Frozen French Fries, YUMWAY Frozen Burger Patty, YUMWAY Frozen Potato Wedges and more,YUMWAY is the trusted choice for <strong> foodservice exporters, bulk buyers, and white-label distributors </strong>across continents.
                            </p>
                            <p class="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                           Whether you're an importer looking for a <strong>frozen French fries exporter from India</strong>, or a HoReCa supplier expanding your clean-label offerings — YUMWAY delivers unmatched consistency, quality, and support. 
                            </p>    

                                                                                                                                            
                            {/* <div class="checklist style4 mb-25" style={{ fontFamily:'helvetica' }}>
                                <ul>
                                    <li>Quality Assurance</li>
                                    <li>Heritage and Legacy</li>
                                    <li>Diverse Product Line</li>
                                    <li>Established Compliance</li>
                                </ul>
                            </div> */}
    

                            {/* <div className="text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                                <Link to="/about" className="th-btn rounded-2" style={{ fontFamily:'helvetica',background:"#F0B323"}}>See Details<i className="fa-solid fa-arrow-right ms-2"></i></Link>
                            </div> */}
                        </div>
                        {/* <div class="col-xl-5 order-2 order-xl-2 mt-xl-0" style={{ marginTop: "500px" }}> */}
                        <div class="col-xl-5 order-2 order-xl-2 " style={{ marginTop: "40px" }}>
                            <div class="testi-card-img " style={{marginLeft:'0px'}}>
                                {/* <div class="img1"> */}
                                    <img src={joinglobal1} alt="Image" />
                                    {/* <video
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    // controls
                                    className="background-video"
                                    >
                                    <source src={abb} type="video/mp4" />
                                    Your browser does not support the video tag.
                                    </video> */}
                                    {/* <img src={testicardimg} alt="Image" /> */}
                                {/* </div> */}
                                {/* <div class="shape1">
                                    <img src={testicardshape} alt="Image" />
                                </div>
                                <div class="shape2">
                                    <img src={testicardshapeimg} alt="Image" />
                                </div>
                                <div class="shape3">
                                    <img src={dishround} alt="Image" />
                                </div>
                                <div class="shape44x">
                                    <img src={roundpotato} alt="Image" />
                                </div> */}
                            </div>
                        </div>

                    </div>
                </div>
            </div>                       


           <div class="about-sec overflow-hidden pb-5">
                <div class="container">
                    <div class="row">

                        <div class="col-xl-5 order-1 order-xl-1 " style={{ marginTop: "40px" }}>
                            <div class="testi-card-img " style={{marginLeft:'0px'}}>
                                {/* <div class="img1"> */}
                                    <img src={tastethediff} alt="Image" />
                                    {/* <video
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    // controls
                                    className="background-video"
                                    >
                                    <source src={abb} type="video/mp4" />
                                    Your browser does not support the video tag.
                                    </video> */}
                                    {/* <img src={testicardimg} alt="Image" /> */}
                                {/* </div> */}
                                {/* <div class="shape1">
                                    <img src={testicardshape} alt="Image" />
                                </div>
                                <div class="shape2">
                                    <img src={testicardshapeimg} alt="Image" />
                                </div>
                                <div class="shape3">
                                    <img src={dishround} alt="Image" />
                                </div>
                                <div class="shape44x">
                                    <img src={roundpotato} alt="Image" />
                                </div> */}
                            </div>
                        </div>                        
                        <div class="col-xl-7 order-2 order-xl-2" style={{ marginTop: "0px" }}>
                            <div class="title-area mb-30 text-center text-xl-start">
                                <span class="sub-title invisible" style={{ fontFamily:'helvetica' }}><span style={{color:"#F0B323"}}>Why YUMWAY Works</span></span>
                                <h2 class="text-uppercase" style={{ fontFamily:'helvetica',color:'#0f1138 !important'}}>
                                    Taste the YUMWAY Difference </h2>
                            </div>
                            {/* <p class="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica',fontWeight:'600' }}>
                            One of India’s Most Trusted Frozen Food Brands — Rooted in Legacy, Loved Worldwide 
                            </p> */}
                            <p class="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                            Golden fries. Real ingredients. No preservatives. 
                            </p>
                            <p class="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                           We offer sampling sessions at our exhibitions — where chefs, importers, and HoReCa buyers can directly experience our:  
                            </p>    

                                                                                                                                            
                            <div class="checklist style1 mb-25" style={{ fontFamily:'helvetica' }}>
                                <ul>
                                    <li><strong>French Fries –</strong> Classic & shoe string </li>
                                    <li><strong>Potato Wedges –</strong> Thick-cut & Rustic</li>
                                    <li><strong>Hash Browns –</strong> Global breakfast favourite </li>
                                    <li><strong>Burger Patties & Aloo Tikki –</strong> Family & QSR-approved</li>
                                    <li><strong>Potato Flakes & Mash –</strong> For commercial kitchens </li>
                                    {/* <li>Establishliance</li> */}
                                </ul>
                            </div>
    

                            {/* <div className="text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                                <Link to="/about" className="th-btn rounded-2" style={{ fontFamily:'helvetica',background:"#F0B323"}}>See Details<i className="fa-solid fa-arrow-right ms-2"></i></Link>
                            </div> */}
                        </div>
                        {/* <div class="col-xl-5 order-2 order-xl-2 mt-xl-0" style={{ marginTop: "500px" }}> */}


                    </div>
                </div>
            </div>  


            <section className="overflow-hidden space" style={{  padding: '20px' }}>
                {/* <div class="title-area mb-30  text-center">
                    <h1 className="why-feature_title titlename text-uppercase" style={{ fontFamily:'helvetica',color:'#0f1138'}}>OUR CERTIFICATIONS</h1>
                </div> */}
                <div class="title-area mb-0 text-center ">
                    <span class="sub-title text-uppercase" style={{ fontFamily:'helvetica' }}><span style={{color:"#F0B323",fontSize:'24px'}}>Certifications & Global Readiness </span></span>
                    <h4 class="" style={{ fontFamily:'helvetica',color:'#0f1138 !important'}}>
                        When You Work With YUMWAY, Compliance Is a Given </h4>
                    <p class="mt-n2 mb-0 text-center" style={{ fontFamily:'helvetica' }}>
                    We meet and exceed international export requirements for frozen potato products. Our certifications include:  
                    </p>                        
                </div>                
                {/* <div class="container"> */}
                    {/* <Slider {...settingstwice}>
                        <div style={{ border: '0px solid #eb2e2e', display: 'inline-block', padding: '26px', borderRadius: '10px' }}>
                            <img className="gray" src={certifications6} alt="Brand Logo" />
                        </div>
                        <div style={{ border: '0px solid #eb2e2e', display: 'inline-block', padding: '26px', borderRadius: '10px' }}>
                            <img className="gray" src={certifications4} alt="Brand Logo" />
                        </div>
                    </Slider> */}

                    {/* <div className="certdiv"style={{ border: '0px solid #eb2e2e', display: 'inline-block', padding: '26px', borderRadius: '10px' }}>
                        <img className="gray" src={certificationsSINGLE} alt="Brand Logo" />
                    </div>                     */}
                <div class="container">
                    <div class="row th-carousel" data-slide-show="6" data-ml-slide-show="5" data-lg-slide-show="4"
                        data-md-slide-show="3" data-sm-slide-show="2" data-xs-slide-show="2">
                        <Slider {...settingsscroll11}>
                            {CertificatImg.map((img, index) => (

                                <div class="col-xl-2 col-lg-3 col-md-3 col-sm2" key={index}>
                                {/* <div class="col-xl-2 col-lg-3 col-md-3 col-sm2" key={index}> */}
                                    <div class="category-border category-border1 py-0">
                                        <div class="category-border_img my-0">
                                            <Link to="#" className="">
                                                {/* <img src={img} alt="Image" style={{ height: '290px' }} /> */}
                                                <img src={img} alt="Image"  />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            ))}

 
                        </Slider>
                    </div>
                </div>                    
                {/* </div> */}
                    <p class="mt-0 mb-25 text-center" style={{ fontFamily:'helvetica' }}>
                        We're proud to be a <strong>top frozen potato exporter from India</strong> — not just for what we make, but how we make it.   
                    </p>  
            </section>                

            <section class="space-bottom contact-form-sec mt-0">
                <div class="container">
                    <div class="reservation-area"style={{ backgroundImage: `url(${feature_bg_51})`, position: 'relative', top: '27px' }}>
                        <div class="title-area mb-0 text-center ">
                            <span class="sub-title" style={{ fontFamily:'helvetica' }}><span style={{color:"#F0B323"}}>YUMWAY Global Table </span></span>
                        </div>                                                   
                        <h4 class="sec-title text-center mb-30" style={{ fontFamily:'helvetica',color:'#ffffff',textTransform: 'uppercase' }}>Become A Country Partner</h4>

            <form
                onSubmit={async (e) => {
                e.preventDefault();

                const formData = {
                    name: e.target.name.value,
                    number: e.target.number.value,
                    subject: e.target.subject.value,
                    message: e.target.message.value,
                };

                try {
                const response = await fetch("https://yumwayfood.com/api.php", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json",
                    },
                    body: JSON.stringify(formData),
                });

                const result = await response.json();
                if (result.success) {
                    alert("Message sent successfully!");
                    e.target.reset();
                } else {
                    alert("Error sending message: " + result.error);
                }
                } catch (error) {
                alert("Something went wrong. Try again later.");
                }
            }}
            className="booking-form3 ajax-contact"
            id="sendform"
            >
            <div className="row">
                <div className="form-group col-lg-4 col-md-6">
                <input type="text" className="form-control rounded-2" name="name" placeholder="Your Name" />
                </div>
                <div className="form-group col-lg-4 col-md-6">
                <input type="tel" className="form-control rounded-2" name="number" placeholder="Phone Number" />
                </div>
                <div className="form-group col-lg-4">
                <input type="text" className="form-control rounded-2" name="subject" placeholder="Subject" />
                </div>
                <div className="form-group col-12">
                <textarea name="message" cols="30" rows="3" className="form-control rounded-2" placeholder="Write Message"></textarea>
                </div>
            </div>
            <div className="text-center">
                <button type="submit" className="th-btn rounded-2" style={{ background: "#F0B323" }}>
                Send Message <i className="fa-solid fa-arrow-right ms-2"></i>
                </button>
            </div>
            </form>
                    </div>
                </div>
            </section>  
           <div class="about-sec overflow-hidden pb-5">
                <div class="container">
                    <div class="row">
                        <div class="col-xl-6 order-1 order-xl-1" style={{ marginTop: "0px" }}>
                            <div class="title-area mb-30 text-center text-xl-start">
                                <span class="sub-title" style={{ fontFamily:'helvetica' }}><span style={{color:"#F0B323"}}>Bulk, White Label, Private Label</span></span>
                                <h2 class="text-uppercase" style={{ fontFamily:'helvetica',color:'#0f1138 !important'}}>
                                    We’re on Shelves You Don’t See — Under Brands You Trust </h2>
                            </div>
                            {/* <p class="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica',fontWeight:'600' }}>
                            One of India’s Most Trusted Frozen Food Brands — Rooted in Legacy, Loved Worldwide 
                            </p> */}
                            <p class="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                            YUMWAY offers scalable, flexible, and premium white-label solutions trusted by <strong>retailers, regional brands, and HoReCa suppliers</strong> across markets.  
                            </p>
    

                                                                                                                                            
                            <div class="checklist style2 mb-25" style={{ fontFamily:'helvetica' }}>
                                <ul>
                                    <li>MOQ-based pricing</li>
                                    <li><strong>Private label French fries and burger patties</strong></li>
                                    <li>Bulk frozen packs (2.5kg to 10kg)</li>
                                    <li>Retail-ready and institutional supply formats </li>
                                    <li>Regional customization </li>
                                </ul>
                            </div>
                            <p class="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                            We are your backend manufacturing partner — built for volume, quality, and discretion. 
                            </p>
                            {/* <div className="text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                                <Link to="/about" className="th-btn rounded-2" style={{ fontFamily:'helvetica',background:"#F0B323"}}>See Details<i className="fa-solid fa-arrow-right ms-2"></i></Link>
                            </div> */}
                        </div>
                        {/* <div class="col-xl-5 order-2 order-xl-2 mt-xl-0" style={{ marginTop: "500px" }}> */}
                        <div class="col-xl-6 order-2 order-xl-2 " style={{ marginTop: "40px" }}>
                            <div class="testi-card-img " style={{marginLeft:'0px'}}>
                                {/* <div class="img1"> */}
                                    <img src={bulk} alt="Image" />
                                    {/* <video
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    // controls
                                    className="background-video"
                                    >
                                    <source src={abb} type="video/mp4" />
                                    Your browser does not support the video tag.
                                    </video> */}
                                    {/* <img src={testicardimg} alt="Image" /> */}
                                {/* </div> */}
                                {/* <div class="shape1">
                                    <img src={testicardshape} alt="Image" />
                                </div>
                                <div class="shape2">
                                    <img src={testicardshapeimg} alt="Image" />
                                </div>
                                <div class="shape3">
                                    <img src={dishround} alt="Image" />
                                </div>
                                <div class="shape44x">
                                    <img src={roundpotato} alt="Image" />
                                </div> */}
                            </div>
                        </div>

                    </div>
                </div>
            </div>  
            {/* <div className="about-sec overflow-hidden pb-5" id="viewmore" style={{ backgroundColor: '#f8f9fa' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 mt-4 mt-xl-2 d-flex justify-content-center align-items-center">
                            <div
                                className="testi-card-img"
                                style={{
                                    backgroundImage: `url(${qualitydrivenupdated1})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    width: '600px',
                                    height: '298px',
                                    boxShadow: '0 10px 20px rgba(0,0,0,0.2)',
                                    borderRadius: '10px',
                                    marginLeft: '-20px'

                                }}
                            ></div>
                        </div>



                        <div className="col-xl-6" style={{ marginTop: '66px' }}>
                            <div className="title-area mb-30 text-center">
                                <h4 className="sec-title" style={{ fontFamily: 'helvetica', color: '#0f1138' }}>QUALITY DRIVEN</h4>





                            </div>
                            <ul className="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily: 'helvetica' }}>
                                <li>At Icedream Global ,Quality is at the heart of everything we do.We are dedicated to delivering frozen food products that meet the highest standards of excellence. From the careful selection of top-quality ingredients to our rigorous production processes, we adhere to the highest industry standards. We provide our customers with safe and reliable products that adhere to food safety regulations, aligning with the directives of regulatory bodies and the internal quality policy set forth by the company.</li>

                            </ul>








                        </div>
                    </div>
                </div>
            </div>

             <div className="space" style={{ marginTop: '-120px'}}>
                <h2 className="section-heading" style={{ fontFamily: 'helvetica' }}>
                    Advantage Icedream
                </h2>
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-xl-4 col-sm-6 d-flex justify-content-center">
                            <div
                                className="contact-feature d-flex align-items-center"
                                style={{
                                    maxWidth: '900px',
                                    margin: '0 auto',
                                    padding: '70px',
                                }}
                            >
                                <div
                                    className="contact-feature_icon me-3"
                                    style={{ width: '130px', height: '100px' }}
                                >
                                    <img
                                        src={farming222}
                                        alt="Icon"
                                        style={{
                                            width: '150%',
                                            height: '100%',
                                            objectFit: 'contain',
                                        }}
                                    />
                                </div>
                                <div>
                                    <h4
                                        className="box-title"
                                        style={{ fontFamily: 'helvetica', color: '#0f1138' }}
                                    >
                                        100% CONTRACT
                                    </h4>
                                    <span className="contact-feature_text">
                                        <a
                                            href="mailto:karan@icedreamglobal.com"
                                            style={{ fontFamily: 'helvetica', color: '#0f1138' }}
                                        >
                                            FARMING
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-4 col-sm-6 d-flex justify-content-center">
                            <div
                                className="contact-feature d-flex align-items-center"
                                style={{
                                    maxWidth: '900px',
                                    margin: '0 auto',
                                    padding: '60px',
                                }}
                            >
                                <div
                                    className="contact-feature_icon me-3"
                                    style={{ width: '130px', height: '100px' }}
                                >
                                    <img
                                        src={quick222}
                                        alt="Icon"
                                        style={{
                                            width: '150%',
                                            height: '100%',
                                            objectFit: 'contain',
                                        }}
                                    />
                                </div>
                                <div>
                                    <h4
                                        className="box-title"
                                        style={{ fontFamily: 'helvetica', color: '#0f1138' }}
                                    >
                                        QUICK
                                    </h4>
                                    <span className="contact-feature_text">
                                        <a
                                            href="mailto:karan@icedreamglobal.com"
                                            style={{ fontFamily: 'helvetica', color: '#0f1138' }}
                                        >
                                            TURNAROUND TIME
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-4 col-sm-6 d-flex justify-content-center">
                            <div
                                className="contact-feature d-flex align-items-center"
                                style={{
                                    maxWidth: '900px',
                                    margin: '0 auto',
                                    padding: '60px',
                                }}
                            >
                                <div
                                    className="contact-feature_icon me-3"
                                    style={{ width: '130px', height: '100px' }}
                                >
                                    <img
                                        src={longshelf222}
                                        alt="Icon"
                                        style={{
                                            width: '150%',
                                            height: '100%',
                                            objectFit: 'contain',
                                        }}
                                    />
                                </div>
                                <div>
                                    <h4
                                        className="box-title"
                                        style={{ fontFamily: 'helvetica', color: '#0f1138' }}
                                    >
                                        LONG SHELF
                                    </h4>
                                    <span className="contact-feature_text">
                                        <a
                                            href="mailto:karan@icedreamglobal.com"
                                            style={{ fontFamily: 'helvetica', color: '#0f1138' }}
                                        >
                                            LIFE-18-24 MONTHS
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-xl-4 col-sm-6 d-flex justify-content-center">
                            <div
                                className="contact-feature d-flex align-items-center"
                                style={{
                                    maxWidth: '900px',
                                    margin: '0 auto',
                                    padding: '70px',
                                }}
                            >
                                <div
                                    className="contact-feature_icon me-3"
                                    style={{ width: '130px', height: '100px' }}
                                >
                                    <img
                                        src={consistent222}
                                        alt="Icon"
                                        style={{
                                            width: '150%',
                                            height: '100%',
                                            objectFit: 'contain',
                                        }}
                                    />
                                </div>
                                <div>
                                    <h4
                                        className="box-title"
                                        style={{ fontFamily: 'helvetica', color: '#0f1138' }}
                                    >
                                        CONSISTENT
                                    </h4>
                                    <span className="contact-feature_text">
                                        <a
                                            href="mailto:karan@icedreamglobal.com"
                                            style={{ fontFamily: 'helvetica', color: '#0f1138' }}
                                        >
                                            QUALITY AND PRICING
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-4 col-sm-6 d-flex justify-content-center">
                            <div
                                className="contact-feature d-flex align-items-center"
                                style={{
                                    maxWidth: '900px',
                                    margin: '0 auto',
                                    padding: '30px',
                                }}
                            >
                                <div
                                    className="contact-feature_icon me-3"
                                    style={{ width: '130px', height: '100px' }}
                                >
                                    <img
                                        src={flexibility222}
                                        alt="Icon"
                                        style={{
                                            width: '150%',
                                            height: '100%',
                                            objectFit: 'contain',
                                        }}
                                    />
                                </div>
                                <div>
                                    <h4
                                        className="box-title"
                                        style={{ fontFamily: 'helvetica', color: '#0f1138' }}
                                    >
                                        FLEXIBILITY TO
                                    </h4>
                                    <span className="contact-feature_text">
                                        <a
                                            href="mailto:karan@icedreamglobal.com"
                                            style={{ fontFamily: 'helvetica', color: '#0f1138' }}
                                        >
                                            CUSTOMIZE
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-4 col-sm-6 d-flex justify-content-center">
                            <div
                                className="contact-feature d-flex align-items-center"
                                style={{
                                    maxWidth: '900px',
                                    margin: '0 auto',
                                    padding: '90px',
                                }}
                            >
                                <div
                                    className="contact-feature_icon me-3"
                                    style={{ width: '130px', height: '100px' }}
                                >
                                    <img
                                        src={tiger222}
                                        alt="Icon"
                                        style={{
                                            width: '150%',
                                            height: '100%',
                                            objectFit: 'contain',
                                        }}
                                    />
                                </div>
                                <div>
                                    <h4
                                        className="box-title"
                                        style={{ fontFamily: 'helvetica', color: '#0f1138' }}
                                    >
                                        PROUDLY MADE
                                    </h4>
                                    <span className="contact-feature_text">
                                        <a
                                            href="mailto:karan@icedreamglobal.com"
                                            style={{ fontFamily: 'helvetica', color: '#0f1138' }}
                                        >
                                            IN INDIA
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br /> */}




            <br />
        

            <Footer />
            <style jsx>
                {`
                    div.certdiv{
                        padding:26px;
                    }
                    @media (max-width: 767px) {
                        div.certdiv{
                            padding:0px;
                        }
                    }      
                    .category-border1:hover {
                        border: none;
                    }       
                    .category-border1 .category-border_img{
                        // border: 1px solid #f0b323;
                        // background-color:#f2f2f2;
                    } 
                    .category-border1 .category-border_img:hover{
                        background-color: #fff2d2;
                    }                                                              
                `}
            </style>
        </div>
    );
};

export default Joinourglobaltable;
